import React from 'react';
import CardBox from '../CardBox';
import { PaymentCard } from '../../requests/caipirinha-api/interfaces/order.interface';
import { toBRL } from '../../utils/money.util';
import CreditCardWithInterest from '../CreditCardWithInterest';

type OrderPcjProps = {
  paymentCard: PaymentCard;
  totalOrder: number;
};

const OrderPcj: React.FC<OrderPcjProps> = (props) => {
  const { paymentCard, totalOrder } = props;
  const totalOrderValue = toBRL(totalOrder || 0);

  return (
    <CardBox>
      <div className='details'>
        <p className='medium' data-cy="credit-card-text">Cartão de crédito</p>
        <strong data-cy="credit-card-name">{paymentCard.simulated?.cardBanner}</strong>
        <hr/>
      </div>
      <div className='details'>
        <p className='medium' data-cy="order-value-text">Valor do pedido</p>
        <p className='medium' data-cy="order-value">{totalOrderValue}</p>
        <hr/>
      </div>

      <CreditCardWithInterest paymentCard={paymentCard}/>
    </CardBox>
  );
};

export default OrderPcj;
